import React from 'react'
import { FormGroup } from '@jsluna/react'
import { PropTypes } from 'prop-types'
import EmployerRow from './EmployerRow'

class EmployerGrid extends React.Component {
  constructor(props) {
    super(props)
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleSelect(employer) {
    this.props.onSelect(employer)
  }

  renderHeaderCell = (title, size) => (
    <th className="ln-c-table__header-cell ln-o-generic--no-wrap" style={{ width: size }}>
      {title}
    </th>
  )

  render() {
    const rows = []
    if (this.props.hasEmployers) {
      this.props.employers.forEach((employer) => {
        const emp = rows.find(r => parseInt(r.key, 0) === employer.id)
        if (emp === undefined && employer !== null) {
          rows.push(<EmployerRow employer={employer} key={employer.id} onSelect={this.handleSelect} />)
        }
      })
      if (rows.length >= 1) {
        return (
          <div className="ln-c-table-container">
          <table className="ln-c-table" style={{ tableLayout: 'fixed' }}>
            <thead className="ln-c-table__header">
              <tr className="ln-c-table__row ln-c-table__header-row">
                {this.renderHeaderCell('Company name', '25%')}
                {this.renderHeaderCell('Code', '10%')}
                {this.renderHeaderCell('Email address', '30%')}
                {this.renderHeaderCell('Email domains for colleague registration', '35%')}
              </tr>
            </thead>
            <tbody className="ln-c-table__body">{rows}</tbody>
          </table>
        </div>
        )
      }
    }
    if (this.props.hasError || !this.props.hasEmployers) {
      return (
        <FormGroup
          className="ln-u-text-align-center ln-u-soft-top"
          name="error"
          error={<span>Error finding your company. Please contact your system administrator.</span>}
        >
          <span />
        </FormGroup>
      )
    }
  }
}

EmployerGrid.propTypes = {
  onSelect: PropTypes.func.isRequired,
  employers: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  hasError: PropTypes.bool.isRequired,
  hasEmployers: PropTypes.bool.isRequired
}

export default EmployerGrid


// WEBPACK FOOTER //
// ./src/components/EmployerGrid/index.jsx